import './App.css';
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";

import Header from './Components/Header/Header';
import Footer from './Components/Footer/Footer';
import AboutProject from './Components/AboutProject/AboutProject';
import Highpoints from './Components/Highpoints/Highpoints';
import Amenities from './Components/Amenities/Amenities';
import PlotSizes from './Components/PlotSizes/PlotSizes';
import Location from './Components/Location/Location';
import PriceAndPayment from './Components/PriceAndPayment/PriceAndPayment';
import Gallery from './Components/Gallery/Gallery';
import Faqs from './Components/Faqs/Faqs';
import Footop from './Components/Footop/Footop';

import Whatsapp from "./Components/Whatsapp/Whatsapp"; 
import PropList from './Components/PropList/PropList';
import Thankyou from './Components/Thankyou/Thankyou';

function App() {
  return (
    <Router>
      <Routes>

        {/* HOME PAGE */}
        <Route 
          path="/" 
          element={
            <>
              <Header />
              <PropList />
              <AboutProject />
              <Highpoints />
              <Amenities />
              <PlotSizes />
              <Location />
              <PriceAndPayment />
              <Gallery />
              <Faqs />
              <Footop />
              <Footer />
              <Whatsapp />
            </>
          } 
        />

        {/* THANKYOU PAGE */}
        <Route path="/thankyou" element={<Thankyou />} />

      </Routes>
    </Router>
  );
}

export default App;
